// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Common, Common as This, System } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    task: Sys.Types.UserTaskTokenDetails;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Common-PlaceholderTask',
    templateUrl: './PlaceholderTask.html',
    styleUrls: ['./PlaceholderTask.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlaceholderTask extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Common.PlaceholderTask';
    $isDialog = false;
    $Modules = $Modules;
    Common = Common;
    System = System;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_task = proxySignal<Sys.Types.UserTaskTokenDetails>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get task() { return component.var_task() },
                set task(value: Sys.Types.UserTaskTokenDetails) { component.var_task.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.task = (undefined)
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            screen.task = Sys.Process.currentTaskDetails
        }
    }
}
